import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import Loader from "../components/BlueButton/Loader.js";
import {word} from "../word.js";
import Api from '../Api.js'
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import qs from "query-string";
import {useLocation,useNavigate} from "react-router-dom";
import DeleteItem from "../components/Notes/DeleteItem.js";
import AddNote from "../components/Notes/AddNote.js";
function Note(props) {
    const location = useLocation()
    const navigate = useNavigate()

    const [note, setNote] = useState([]);
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const query = qs.parse(location.search, {arrayFormat: 'comma'});

    useEffect(() => {
        fetchNotes();
    }, [location.search]);

    const fetchNotes = async () => {
        setLoading(true);
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        const {data} = await Api.getNotes(querystring?`&${querystring}`:querystring)

        setNote(data.results);
        setCount(data.count);
        setLoading(false);
    };

    const handlePageChange =async (pageNumber) => {
        const offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        let querystring = qs.stringify({ offset,page:pageNumber }, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`)
        await fetchNotes({ offset,page:pageNumber });
    };


    const renderNotes = () => {
        if (loading) {
            return (
                <div className="loaderMargin">
                    <Loader type="Oval" size={30} />
                </div>
            );
        }
        return note.map((item, index) => (
            <div className="note-item" key={index}>
                <div className="note-item-title">{item.title}</div>
                <div className="tool-tip-cont">
                    <div className="tool-tip">Ջնջել</div>
                    <i className="fas fa-trash-alt" onClick={() => {
                        setIdToDelete(item.id);
                    }}/>
                </div>
            </div>
        ));
    };
    return (
        <Wrapper>
            <div className='users'>
                <div className='plus-cont' onClick={() => setShow(true)}>
                    <span className="plus">+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>
                {renderNotes()}
                {count > 10 && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+query.offset? query.offset/10 + 1  : 1}
                            totalItems={count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(count / 10) || 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
            {idToDelete?<DeleteItem open={idToDelete} getData={fetchNotes} setOpen={setIdToDelete}/>:null}
            {show?<AddNote onHide={async () => {
                setShow(false)
                await fetchNotes()
            }} show={show}/>:null}

        </Wrapper>
    );
}

export default Note;